package meineglasfaser.api

import kotlinx.serialization.Serializable
import meineglasfaser.api.ubl.UBLAmount

@Serializable
data class ShopPriceGroup(
    val monthly: UBLAmount,
    val yearly: UBLAmount,
    val once: UBLAmount,
) {
    operator fun plus(other: ShopPriceGroup): ShopPriceGroup = ShopPriceGroup(
        monthly = monthly + other.monthly,
        yearly = yearly + other.yearly,
        once = once + other.once,
    )

    operator fun times(n: Int): ShopPriceGroup = ShopPriceGroup(
        monthly = monthly * n,
        yearly = yearly * n,
        once = once * n,
    )

    companion object {
        val ZERO_EUR = ShopPriceGroup(
            monthly = UBLAmount.ZERO_EUR,
            yearly = UBLAmount.ZERO_EUR,
            once = UBLAmount.ZERO_EUR,
        )
    }
}

@Serializable
data class ShopNetworkCategory(
    val id: String,
    val title: String,
    val summary: String,
    val details: String,
    val imageUrl: String?,
)

@Serializable
data class ShopNetwork(
    val id: String,
    val title: String,
    val summary: String,
    val details: String,
    val imageUrl: String?,
)

@Serializable
data class ShopAddonGroup(
    val id: String,
    val orderPos: Int,
    val title: String,
    val summary: String,
    val imageUrl: String? = null,
)

@Serializable
data class ShopAddonGroupWithProducts(
    val addonGroup: ShopAddonGroup,
    val products: List<Product>,
)
